import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  MetaDataInterface,
  StudentResultInterface,
} from "../../Constants/Interfaces/bodyInterface/studentResult.interface";
import { RESULT_STATUS } from "../../Constants/Enums/Results.enum";
import { computeGradeFromMarks } from "../../Services/results/results";
import { getValue } from "../../utils/object.utils";

const initialState = {
  selectedStudentForResult: {
    avatar: null,
    first_name: "",
    last_name: "",
    full_name: "",
    gender: "",
    roll_no: "",
    result_status: RESULT_STATUS.PENDING,
    result_entries: [],
    remarks: "",
    metadata: {},
  } as StudentResultInterface,
  pageNo: 1,
  paginatedStudentResultList: [],
};

export const studentResultSlice = createSlice({
  name: "studentResult",
  initialState,
  reducers: {
    setSelectedStudentForResult: (
      state,
      action: PayloadAction<StudentResultInterface>
    ) => {
      state.selectedStudentForResult = action.payload;
    },

    updateMarksInResultEntry: (
      state,
      action: PayloadAction<{ subjectId: number; value: number }>
    ) => {
      const resultEntry = state.selectedStudentForResult.result_entries;

      const subjectId = action.payload.subjectId;

      const updatingEntry = resultEntry.find(
        ({ subject_id: entrySubjectId }) => subjectId === entrySubjectId
      );

      if (!updatingEntry) return;
      const fullMarks = getValue(updatingEntry, "full_marks", 100);
      const marks = Number(action.payload.value);

      const grade = computeGradeFromMarks({ marks, fullMarks });

      updatingEntry.marks = marks;
      updatingEntry.grade = grade;
    },

    updateGradeInResultEntry: (
      state,
      action: PayloadAction<{ subjectId: number; value: string }>
    ) => {
      const resultEntry = state.selectedStudentForResult.result_entries;

      const subjectId = action.payload.subjectId;

      const updatingEntry = resultEntry.find(
        ({ subject_id: entrySubjectId }) => subjectId === entrySubjectId
      );

      if (!updatingEntry) return;

      updatingEntry.grade = action.payload.value;
    },

    updatePageNo: (state, action: PayloadAction<number>) => {
      state.pageNo = action.payload;
    },

    setPaginatedStudentResultList: (state, action: PayloadAction<any>) => {
      state.paginatedStudentResultList = action.payload;
    },

    setRemarks: (state, action: PayloadAction<string>) => {
      state.selectedStudentForResult.remarks = action.payload;
    },

    setMetaData: (state, action: PayloadAction<MetaDataInterface>) => {
      state.selectedStudentForResult.metadata = action.payload;
    },
  },
});
export const {
  setSelectedStudentForResult,
  updateMarksInResultEntry,
  updateGradeInResultEntry,
  updatePageNo,
  setRemarks,
  setMetaData,
  setPaginatedStudentResultList,
} = studentResultSlice.actions;
export const studentResultReducer = studentResultSlice.reducer;
